const v2 = `/v2`;

const authBasePrefix = `${v2}/Auth/`;
export const auth = {
  authenticate: () => `${authBasePrefix}authenticate`,
  refreshToken: () => `${authBasePrefix}refresh`,
};

const registrationBasePrefix = `${v2}/Registration/`;
export const registration = {
  signup: () => registrationBasePrefix,
  // PERSONAL
  register: () => `${registrationBasePrefix}register`,
  verify: () => `${registrationBasePrefix}verify`,
  resendCode: () => `${registrationBasePrefix}resend-code`,
  registerComplete: () => `${registrationBasePrefix}register-complete`,
};

const accountsBasePrefix = `${v2}/Accounts/`;
export const accounts = {
  getAccounts: () => `${accountsBasePrefix}GetAccounts`,
  getAccountById: () => `${accountsBasePrefix}GetAccountById`,
  getAccountsForIntegrations: () => `${accountsBasePrefix}GetAccountsForIntegrations`,
  getCardAccountBalanceReport: () => `${accountsBasePrefix}GetCardAccountBalanceReport`,
  getPaymentAccountBalanceReport: () => `${accountsBasePrefix}GetPaymentAccountBalanceReport`,
  updateDetails: () => `${accountsBasePrefix}UpdateAccountInfo`,
  generateAccountConfirmationLetter: (id: number) => `${accountsBasePrefix}generateAccountConfirmationLetter/${id}`,
  getTransactionsWithPayments: () => `${accountsBasePrefix}transactions-with-payments`,
  getDocuments: () => `${accountsBasePrefix}GetDocuments`,
  downloadDocument: () => `${accountsBasePrefix}DownloadDocument`,
};

const alertsBasePrefix = `${v2}/AlertSubscriptions/`;
export const alerts = {
  minimalBalanceAdd: () => `${alertsBasePrefix}subscription-minimal-balance`,
  minimalBalanceUpdate: (subscriptionId: string) => `${alertsBasePrefix}subscription-minimal-balance/${subscriptionId}`,
  declinedAuthAdd: () => `${alertsBasePrefix}subscription-declined-auth`,
  declinedAuthUpdate: (subscriptionId: string) => `${alertsBasePrefix}subscription-declined-auth/${subscriptionId}`,
  deleteSubscription: (subscriptionId: string) => `${alertsBasePrefix}subscription/${subscriptionId}`,
};

const cardsBasePrefix = `${v2}/Cards/`;
export const cards = {
  getCards: () => `${cardsBasePrefix}`,
  getCard: (cardId: number) => `${cardsBasePrefix}${cardId}`,
  getCardsByAccounts: () => `${cardsBasePrefix}byaccounts`,
  getCreditLimit: (cardId: number) => `${cardsBasePrefix}${cardId}/credit-limit`,
  getDebitLimit: (cardId: number) => `${cardsBasePrefix}${cardId}/debit-limit`,
  activate: (cardId: number) => `${cardsBasePrefix}${cardId}/activate`,
  freezeCard: (cardId: number) => `${cardsBasePrefix}${cardId}/freeze`,
  unfreezeCard: (cardId: number) => `${cardsBasePrefix}${cardId}/unfreeze`,
  remindPin: (cardId: number) => `${cardsBasePrefix}${cardId}/remindPin`,
  updateLabel: (cardId: number) => `${cardsBasePrefix}${cardId}/label`,
  updateCategory: (cardId: number) => `${cardsBasePrefix}${cardId}/category`,
  reportLostStolen: (cardId: number) => `${cardsBasePrefix}${cardId}/reportLostStolen`,
  updateCreditLimit: (cardId: string) => `${cardsBasePrefix}${cardId}/card-limit/credit `,
  updateDebitLimit: (cardId: string) => `${cardsBasePrefix}${cardId}/card-limit/debit`,
  backgroundTasks: () => `${v2}/BackgroundTasks`,
};

const dashboardPrefix = `${v2}/Dashboard/`;
export const dashboard = {
  notifications: () => `${dashboardPrefix}notifications`,
  notificationDetail: (alertGuid: string) => `${dashboardPrefix}notifications/${alertGuid}/detailed`,
  summaries: () => `${dashboardPrefix}summaries`,
  spending: (currency: string) => `${dashboardPrefix}summaries/${currency}/spending`,
  expenseCategories: (currency: string) => `${dashboardPrefix}summaries/${currency}/expense-categories`,
  merchants: (currency: string) => `${dashboardPrefix}summaries/${currency}/merchants`,
  accountSummary: () => `${dashboardPrefix}GetAccountSummary`,
  paymentSummary: () => `${dashboardPrefix}GetPaymentSummary`,
};

const transactionsBasePrefix = `${v2}/Transactions/`;
export const transactions = {
  getTransactions: () => `${transactionsBasePrefix}GetList`,
  updateTransaction: () => transactionsBasePrefix,
  getReceipt: (refNum: string) => `${transactionsBasePrefix}receipt/${refNum}`,
  createReceipt: (refNum: string) => `${transactionsBasePrefix}${refNum}/receipt`,
  removeReceipt: (refNum: string) => `${transactionsBasePrefix}receipt/${refNum}`,
};

const usersBasePrefix = `${v2}/Users/`;
export const users = {
  getUsers: () => usersBasePrefix,
  getUser: (id: string) => `${usersBasePrefix}${id}`,
  updateUser: (id: string) => `${usersBasePrefix}${id}`,
  deleteUser: (id: string) => `${usersBasePrefix}${id}`,
  lockUser: (id: string) => `${usersBasePrefix}${id}/lock`,
  unlockUser: (id: string) => `${usersBasePrefix}${id}/unlock`,
  updatePassword: () => `${usersBasePrefix}password`,
  addUserAccounts: () => `${usersBasePrefix}assign/accounts`,
  addUserCards: () => `${usersBasePrefix}assign/cards`,
  deleteUserAccounts: () => `${usersBasePrefix}disassociate/account`,
  deleteUserCards: () => `${usersBasePrefix}disassociate/card`,
  degenerateCode: () => `${usersBasePrefix}GenerateCode`,
};

const statementsBasePrefix = `${v2}/Statements/`;
export const statements = {
  getStatements: () => statementsBasePrefix,
  download: (id: string) => `${statementsBasePrefix}${id}/download`,
  downloadv1: () => `${statementsBasePrefix}downloadv1`,
  downloadSepaStatement: () => `${statementsBasePrefix}DownloadSepaStatement`,
  generateStatementOfFees: () => `${statementsBasePrefix}GenerateStatementOfFees`,
};

const miscBasePrefix = `${v2}/Misc/`;
export const misc = {
  getCountries: () => `${miscBasePrefix}GetCountries`,
  getCurrencies: () => `${miscBasePrefix}GetCurrencies`,
  getAvailableCurrencies: () => `${miscBasePrefix}GetAvailableCurrencies`,
  getCountryProvinces: () => `${miscBasePrefix}GetCountryProvinces`,
  getTransferCurrencies: () => `${miscBasePrefix}GetTransferCurrencies`,
};

const messageBasePrefix = `${v2}/Messages/`;
export const messages = {
  getThreads: () => `${messageBasePrefix}threads`,
  getThreadsMessages: (groupId: string) => `${messageBasePrefix}threads/${groupId}`,
  readThread: () => `${messageBasePrefix}read`,
  deleteThread: (groupId: string) => `${messageBasePrefix}${groupId}`,
  addAttachments: (messageId: string) => `${messageBasePrefix}${messageId}/attachments`,
  addMessage: () => messageBasePrefix,
  downloadAttachment: (fileId: string, messageId: string) => `${messageBasePrefix}${messageId}/attachments/${fileId}`,
  removeAttachment: (fileId: string, messageId: string) => `${messageBasePrefix}${messageId}/attachments/${fileId}`,
};

const profileBasePrefix = `${v2}/Profile/`;
export const profile = {
  getProfile: () => `${profileBasePrefix}`,
  getProfileFeatures: () => `${profileBasePrefix}features`,
  updateAddress: () => `${profileBasePrefix}address`,
};

const reportBasePrefix = `${v2}/Reports/`;
export const reports = {
  generateCardAccountBalanceReport: () => `${reportBasePrefix}GenerateCardAccountBalanceReport`,
  generatePaymentAccountBalanceReport: () => `${reportBasePrefix}GeneratePaymentAccountBalanceReport`,
  generateTransactionReport: () => `${reportBasePrefix}GenerateTransactionReport`,
  generatePaymentReport: () => `${reportBasePrefix}GeneratePaymentReport`,
};

const paymentBasePrefix = `${v2}/Payment/`;
export const payments = {
  getPaymentById: () => `${paymentBasePrefix}GetById`,
  getPaymentsByAccounts: () => `${paymentBasePrefix}GetPaymentsByAccounts`,
  getPaymentsByRecipientId: () => `${paymentBasePrefix}GetPaymentsByRecipientId`,
  getGenerateReceiptById: () => `${paymentBasePrefix}GenerateReceiptById`,
  generateOutgoingPayment: (id: string) => `${paymentBasePrefix}generateOutgoingPayment/${id}`,
  validateIban: (iban: string) => `${paymentBasePrefix}validate-iban/${iban}`,
};

const integrationsBasePrefix = `${v2}/Integrations/`;
export const integrations = {
  getIntegrations: () => integrationsBasePrefix,
  connect: (service: string) => `${integrationsBasePrefix}connect/${service}`,
  confirm: (service: string, code: string) => `${integrationsBasePrefix}connect/${service}/callbackcode/${code}`,
  disconnect: (service: string) => `${integrationsBasePrefix}disconnect/${service}`,
  disconnectAccount: (service: string, accountId: string) => `${integrationsBasePrefix}disconnect/${service}/${accountId}`,
  getXeroAccountTypes: () => `${integrationsBasePrefix}xero/accounttypes`,
  setXeroAccountType: (accountId: string, accountType: string) => `${integrationsBasePrefix}xero/account/${accountId}/accounttypes/${accountType}`,
};

const recipientsPrefix = `${v2}/Recipients/`;
export const recipients = {
  getRecipients: () => `${recipientsPrefix}GetList`,
  getRecipient: () => `${recipientsPrefix}GetById`,
  getRecentRecipients: () => `${recipientsPrefix}GetRecent`,
  createRecipient: () => recipientsPrefix,
  updateRecipient: () => recipientsPrefix,
  deleteRecipient: (id: string) => `${recipientsPrefix}${id}`,
  getMandatoryFields: () => `${recipientsPrefix}GetRecipientMandatoryFields`,
};

const transferRequestPrefix = `${v2}/TransferRequest/`;
export const transferRequests = {
  getFee: () => `${transferRequestPrefix}GetFee`,
  getList: () => `${transferRequestPrefix}GetList`,
  create: () => `${transferRequestPrefix}Create`,
  update: () => `${transferRequestPrefix}Update`,
  updateStatus: () => `${transferRequestPrefix}UpdateStatus`,
  getDocuments: () => `${transferRequestPrefix}GetDocuments`,
  downloadDocument: () => `${transferRequestPrefix}DownloadDocument`,
  createDocument: () => `${transferRequestPrefix}CreateDocument`,
  deleteDocument: () => `${transferRequestPrefix}DeleteDocument`,
  getLimits: () => `${transferRequestPrefix}GetTransferLimits`,
  getTransferReasons: () => `${transferRequestPrefix}GetTransferReasons`,
  getFxRate: () => `${transferRequestPrefix}GetFxRate`,
};
